import { useEffect, useState } from "react";

export const useIsContentOverflows = <T extends HTMLElement>(
  ref: React.RefObject<T>,
  options?: {
    enabled?: boolean;
  },
) => {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const { enabled = true } = options ?? {};

  useEffect(() => {
    if (!enabled) {
      setIsOverflowing(false);
      return;
    }

    const updateOverflowState = () => {
      const el = ref.current;

      if (el) {
        setIsOverflowing(Boolean(el.scrollWidth > el.clientWidth));
      }
    };

    updateOverflowState();
    window.addEventListener("resize", updateOverflowState);

    return () => {
      window.removeEventListener("resize", updateOverflowState);
    };
  }, [ref, enabled]);

  return isOverflowing;
};
